<template>
  <div class="main_box">
    <el-card class="box-card">
      <el-form :inline="true" :model="searchFormObj" class="demo-form-inline">
        <el-form-item label="订单号" class="inline-form-item">
          <el-input
            v-model="searchFormObj.order_no"
            style="width: 200px; margin-left: 10px; margin-right: 10px;"
            clearable
            placeholder="请输入订单号"
            @keyup.enter.native="onSearchSubmit"
          />
        </el-form-item>
        <el-form-item label="用户昵称" class="inline-form-item">
          <el-input
            v-model="searchFormObj.nickname"
            style="width: 200px; margin-left: 10px; margin-right: 10px;"
            clearable
            placeholder="请输入用户昵称"
            @keyup.enter.native="onSearchSubmit"
          />
        </el-form-item>
        <el-form-item label="时间：" class="inline-form-item">
          <el-date-picker
            v-model="timeArr"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            :picker-options="pickerOptions"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="订单状态" class="inline-form-item">
          <el-select v-model="searchFormObj.order_status" placeholder="请选择" clearable>
            <el-option
              label="全部"
              value="-99"
            />
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearchSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-refresh" @click="onSearchEmptySubmit">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="table_box">
      <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" border>
        <el-table-column prop="id" label="订单id" align="center" />
        <el-table-column prop="nickname" label="用户昵称" align="center" />
        <el-table-column prop="head_img" label="头像" align="center" width="70px">
            <template slot-scope="scope">
              <div v-if="scope.row.head_img" class="el-tooltip content item">
                <el-image style="width: 50px; height: 50px" :src="scope.row.head_img" fit="fit" />
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="d_start_time" label="投放时间" align="center" width="90px">
            <template slot-scope="scope">
              <div v-if="scope.row.d_start_time">
                <div>{{scope.row.dateN1 + 1}}天</div>
                <div>{{scope.row.dateN2}}</div>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="pay_device" label="投放设备" align="center">
            <template slot-scope="scope">
                <div>{{scope.row.pay_device_count}}台</div>
                <div>({{scope.row.pay_device}})</div>
            </template>
        </el-table-column>
        <el-table-column prop="material_name" label="素材名字" align="center" />
        <el-table-column prop="material_img" label="图片" align="center" width="90px">
            <template slot-scope="scope">
              <div v-if="scope.row.material_img" class="el-tooltip content item">
                <el-image style="width: 70px; height: 70px;cursor: pointer;" @click="materialImg(scope.row.material_img)" :src="scope.row.material_img" fit="fit" />

                <!-- <el-image
                  style="width: 60px; height: 60px"
                  :src="scope.row.material_img"
                  fit="cover"
                  :preview-src-list="[scope.row.material_img]">
                </el-image> -->
              </div>
            </template>
        </el-table-column>
        <!-- <el-table-column prop="feeNew" label="金额" align="center" /> -->
        <el-table-column prop="feeNew" label="金额" align="center">
            <template slot-scope="scope">
                <div>{{scope.row.feeNew}}元</div>
            </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center" />
        <el-table-column prop="pay_at" label="支付时间" align="center" />
        <el-table-column prop="refunded_at" label="退款时间" align="center" />
        <el-table-column prop="order_status" label="订单状态" align="center">
          <template slot-scope="scope">
            {{ typeMap.get(scope.row.order_status.toString()) }}
          </template>
        </el-table-column>
        <el-table-column prop="order_status" label="操作" align="center" width="100px">
          <template slot-scope="scope">
            <el-button v-if="scope.row.order_status == 4" type="primary" @click="Audit(scope.row)">立即审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_box">
      <el-pagination
        :current-page="searchFormObj.page"
        background
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchFormObj.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
        :visible.sync="isShowImageDialog"
        @closed="clearImg"
      >
        <!-- <el-carousel indicator-position="outside" height="500px">
          <el-carousel-item v-for="src in imgs">
            <img :src="src" style="max-width: 100%;max-height: 100%;display: block; margin: 0 auto;"/>
          </el-carousel-item>
        </el-carousel> -->
        <img :src="imgs" style=" width: 100%; height: 100%;display: block; margin: 0 auto;"/>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="sendDialogVisible"
      width="50%"
    >
      <el-form class="demo-form-inline">
        <el-form-item label="">
           <div v-if="material_name" class="el-tooltip content item" style="color: #000000; font-weight: bold; font-size: 20px;">
              {{material_name}}
          </div>
        </el-form-item>
        <el-form-item label="">
          <div v-if="material_img" class="el-tooltip content item" style="text-align: center;">
            <el-image style="max-width: 600px; height: auto; margin: 0 auto; " :src="material_img" fit="fit" />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="isSending3" type="danger" @click="notThrough(3)">审核不通过</el-button>
        <el-button :loading="isSending2" type="success" @click="notThrough(2)">审核通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as CustomerServiceApi from '@/api/customerservice'
import { deepClone } from '@/utils'
import moment from 'moment'
const end = moment(new Date()).format('YYYY-MM-DD')
const start = moment(new Date(new Date(new Date().toLocaleDateString()).getTime() - (7 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD')
// 商品列表
export default {
  name: 'backOrderList',
  // components: {
  //   TreeTransfer
  // },
  data() {
    return {
      tableData: [],
      total: 0,
      loading: false,
      isSending3: false,
      isSending2: false,
      timeArr: [start, end],
      typeOptions: [
        { value: '0', label: '未支付' },
        { value: '1', label: '已上刊' },
        { value: '2', label: '已审核待上刊' },
        { value: '3', label: '审核不通过已取消' },
        { value: '4', label: '已支付待审核' },
        { value: '-1', label: '已取消' }
      ],
      appRang: [],
      imgs: [],
      sendDialogVisible: false,
      isShowImageDialog: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '今天',
          onClick(picker) {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + (24 * 60 * 60 * 1000) - 1)
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() - 1)
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - (24 * 60 * 60 * 1000))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '近三天',
          onClick(picker) {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() - 1)
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - (3 * 24 * 60 * 60 * 1000))
            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', [start, end])
          }
        }]
      },
      formData: {},
      material_img: '',
      material_name: '',
      searchFormObj: { order_no: '', order_status: '-99', nickname: '', use_platform: '', start_time: '', end_time: '', limit: 20, page: 1 }
    }
  },
  computed: {
    typeMap() {
      return new Map(this.typeOptions.map(item => [item.value, item.label]))
    }
  },
  created() {
    this.getBackOrderList()
  },
  methods: {
    clearImg() {
      this.imgs = null
      this.isShowImageDialog = false
    },
    materialImg(e) {
      this.isShowImageDialog = true
      this.imgs = []
      this.imgs.push(e)
      console.log('e---', this.imgs)
    },
    notThrough(e) {
      // console.log('e--', e)
      if (e == 3) {
        this.isSending3 = true
      } else {
        this.isSending2 = true
      }
      const formData = new FormData()
      formData.append('order_status', e)
      formData.append('id', this.formData.id)
      CustomerServiceApi.orderReview(formData)
        .then((res) => {
          // console.log('res----', res)
          if (e == 3) {
            this.isSending3 = false
          } else {
            this.isSending2 = false
          }
          this.sendDialogVisible = false
          if (res.data.Status == 200) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.getBackOrderList()
          } else if (res.data.Status == 252) {
            this.$message.error(res.data.Result.ErrorMsg)
          }
        })
        .catch(() => {
          this.sendDialogVisible = false
        })
    },
    // 查看详细
    Audit(row) {
      // console.log('1111', row)
      this.sendDialogVisible = true
      this.formData.id = row.id
      this.material_img = row.material_img
      this.material_name = row.material_name
    },
    onSearchSubmit() {
      this.searchFormObj.page = 1
      this.getBackOrderList()
    },
    onSearchEmptySubmit() {
      this.searchFormObj = { order_no: '', order_status: '-99', nickname: '', use_platform: '', start_time: '', end_time: '', limit: 20, page: 1 }
      this.appRang = []
      this.getBackOrderList()
    },
    getBackOrderList() {
      this.loading = true
      var query = deepClone(this.searchFormObj)
      if (this.timeArr && this.timeArr.length > 1) {
        query.start_time = this.timeArr[0]
        query.end_time = this.timeArr[1]
      } else {
        query.start_time = ''
        query.end_time = ''
      }
      CustomerServiceApi.getBackOrderList(query)
        .then((res) => {
          if (res.data.Status == 200) {
            this.loading = false
            res.data.Result.list.forEach(item => {
              if (item.d_end_time && item.d_start_time) {
                const DateA = this.DateDiff(item.d_end_time, item.d_start_time)
                item.dateN1 = DateA
                item.dateN2 = '(' + item.d_start_time.substring(5, 10).replace('-', '') + '-' + item.d_end_time.substring(5, 10).replace('-', '') + ')'
              }
              item.feeNew = Number(item.fee) / 100
            })
            this.tableData = res.data.Result.list
            this.total = Number(res.data.Result.count)
            console.log('this.tableData', res.data.Result.list)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    DateDiff(sDate1, sDate2) { // sDate1和sDate2是2006-12-18格式
      var aDate, oDate1, oDate2, iDays
      aDate = sDate1.split('-')
      oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) // 转换为12-18-2006格式
      aDate = sDate2.split('-')
      oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) // 把相差的毫秒数转换为天数
      // console.log('时间', iDays)
      return iDays
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.searchFormObj.limit = val
      this.searchFormObj.page = 1
      this.getBackOrderList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.searchFormObj.page = val
      this.getBackOrderList()
    }
  }

}
</script>
<style lang='less' scoped>
.page_box {
  margin-top: 20px;
  text-align: right;
}
/deep/ .gutter{
    display: block !important;
}
/deep/ .el-dialog__footer{
    text-align: center;
}
/deep/.el-dialog__headerbtn{
  top: 10px;
  right: 10px;
}
/deep/.el-dialog__header{
  padding: 0;
}
/deep/.el-dialog__headerbtn .el-dialog__close{
  color: #409eff;
}
</style>
